import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const ListActivityPage = loadable(() => import('./ListActivityPage'), {
  fallback: <Loader />
});
// Socket
import { io } from 'socket.io-client';
const socketURL = process.env.MIX_COMMON_SOCKET_URL ?? 'https://technource.co.in:3003';
const socket = io(socketURL, {
  transports: ['websocket', 'polling'], // Optional: ensure WebSocket is used
  secure: true, // Optional: ensure SSL/TLS
  query: {
    t: Date.now()
  }
});

const ActivityRoute = ({ t, setTabLoading }) => {
  return [
    <Route
      key={'activity_view'}
      exact
      path="/view/:projectId/activities"
      element={<ListActivityPage t={t} socket={socket} />}
    />,
  ];
};
ActivityRoute.propTypes = {};
export default ActivityRoute;
